if (!customElements.get('tab-collection')) {
  customElements.define(
    'tab-collection',
    class TabCollection extends HTMLElement {
      constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        // 防止 Shopify Theme Editor 重复 connected
        this.removeEventListener('click', this.handleClick);
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(event) {
        const tab = event.target.closest('.tab_collection_tag');

        // 点击的不是 tab
        if (!tab) return;

        // 防止拿到其他 tab-collection 里面的 tab
        if (tab.closest('tab-collection') !== this) return;

        const tabs = Array.from(
          this.querySelectorAll('.tab_collection_tag')
        );

        const contents = Array.from(
          this.querySelectorAll('.tab-collection-content')
        );

        const index = tabs.indexOf(tab);

        if (index === -1) return;

        console.log('当前 section:', this.dataset.sectionId);
        console.log('点击 index:', index);

        // tab active
        tabs.forEach((item) => {
          item.classList.remove('tc_active');
        });

        tab.classList.add('tc_active');

        // content active
        contents.forEach((item) => {
          item.classList.remove('tab_collection_content_active');
        });

        if (contents[index]) {
          contents[index].classList.add(
            'tab_collection_content_active'
          );
        }
      }
    }
  );
}